<template>
  <div class="form-group" :class="{ inline: inline }">
    <label v-if="showLabel" >{{label}}</label>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      label: String,
      showLabel: { type: Boolean, default: true },
      inline: Boolean
    }
  }
</script>

<style scoped lang="scss">
  @import "../../styles/variables";

 .form-group {
   width: 100%;

   label {
     display: block;
     color: $label-color;
     font-weight: 500;
     margin-bottom: 5px;
     text-transform: uppercase;
     font-size: 12px;
   }

   &.inline {
     display: flex;
     align-items: center;
     flex-wrap: wrap;

     label {
       margin-bottom: 0;
       display: inline;
       padding-right: 5px;
     }
   }
 }
</style>